import { ReactElement } from "react";

export function FranchiseNoContent (): ReactElement {
  return <>A franquia não foi encontrada</>
}